var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import { cx, css } from 'emotion';
import * as colors from '../../styles/colors';
import spacing from '../../styles/spacing';
import { label } from '../typography/typographyClasses';
var wrapper = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  margin-bottom: ", ";\n"], ["\n  display: block;\n  margin-bottom: ", ";\n"])), spacing.xs);
var themes = {
  light: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), colors.black),
  dark: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), colors.white)
};
var disabledStyles = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors.grey3);
export default (function (_a) {
  var className = _a.className,
      theme = _a.theme,
      disabled = _a.disabled;
  return cx(wrapper, label, themes[theme], disabled ? disabledStyles : '', className);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;